import React from 'react';
import '../pages/ViewDataPage/styles.css';

const TableSkeleton = ({ columns = [], rowCount = 5 }) => {
  return (
    <div className="view-data-table-container">
      <table className="view-data-table table-skeleton">
        <thead>
          <tr>
            <th style={{ width: 40 }}>
              <div className="skeleton-checkbox"></div>
            </th>
            {columns.map((column, index) => (
              <th key={index}>
                <div className="skeleton-content" style={{ width: `${Math.random() * 40 + 60}%` }}></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex} className="skeleton-row">
              <td className="skeleton-cell">
                <div className="skeleton-checkbox"></div>
              </td>
              {columns.map((_, colIndex) => (
                <td key={colIndex} className="skeleton-cell">
                  <div 
                    className="skeleton-content" 
                    style={{ 
                      width: `${Math.random() * 50 + 30}%`,
                      animationDelay: `${(rowIndex + colIndex) * 0.1}s`
                    }}
                  ></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
